import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

export default function ProductSkeleton() {
    const count = 9;

    return (
        <Grid container spacing={2} paddingY={2}>
            {Array.from({ length: count }).map((_, index) => (
                <Grid key={index} item xs={2} md={4} padding={2}>
                    <Skeleton variant="rectangular" width="100%" height={200} />
                    <Skeleton variant="text" />
                    <Skeleton variant="text" />
                </Grid>
            ))}
        </Grid>
    );
}
